import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Stack, Switch } from "@mui/material";
import {
  AccordionContainer,
  PlansDetailsContainer,
} from "../../pages/Billing/styles";
import { tierMap } from "../../pages/Billing/types";
import { styles } from "./styles";
import { MinorPlanDetails } from "./MinorPlanDetails";
import { MajorPlanDetails } from "./MajorPlanDetails";
import { useContext, useState } from "react";
import { UserDetailsContext } from "../../contexts";
import { EnterpriseDetails } from "./EnterpriseDetails";
import { styled } from "@mui/material/styles";

const SubscriptionSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export const SubscriptionPlans: React.FC = () => {
  const { subscriptionTier } = useContext(UserDetailsContext);
  const [isYearly, setIsYearly] = useState(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      // setExpanded(isExpanded ? panel : false);
    };

  const handleChangeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsYearly(event.target.checked);
  };
  return (
    <>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <Typography>Monthly</Typography>
        <SubscriptionSwitch onChange={handleChangeSwitch} checked={isYearly} />
        <Typography>Yearly (Save 20%)</Typography>
      </Stack>
      <PlansDetailsContainer>
        <Box
          style={
            tierMap[subscriptionTier] === "Minor"
              ? styles.selectedSubscriptionPlan
              : { padding: "20px" }
          }
        >
          <h5
            style={
              tierMap[subscriptionTier] === "Minor"
                ? styles.selectedPlanHeading
                : styles.planHeading
            }
          >
            OmMuse Minor Subscription
          </h5>
          <MinorPlanDetails isYearly={isYearly} />
        </Box>
        <Box
          style={
            tierMap[subscriptionTier] === "Major"
              ? styles.selectedSubscriptionPlan
              : { padding: "20px" }
          }
        >
          <h5
            style={
              tierMap[subscriptionTier] === "Major"
                ? styles.selectedPlanHeading
                : styles.planHeading
            }
          >
            OmMuse Major Subscription
          </h5>
          <MajorPlanDetails isYearly={isYearly}/>
        </Box>
        <Box
          style={
            tierMap[subscriptionTier] === "Enterprise"
              ? styles.selectedSubscriptionPlan
              : { padding: "20px" }
          }
        >
          <h5 style={styles.planHeading}>OmMuse Enterprise Subscription</h5>
          <EnterpriseDetails />
        </Box>
      </PlansDetailsContainer>
      <AccordionContainer>
        <Accordion
          expanded={true}
          onChange={handleChange("panel1")}
          style={
            tierMap[subscriptionTier] === "Minor"
              ? { backgroundColor: "#1A8899" }
              : styles.accordion
          }
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            style={{ textAlign: "left" }}
          >
            <Box sx={styles.accordionItems}>
              <Typography sx={{ marginLeft: "20px" }}>Minor</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <MinorPlanDetails isYearly={isYearly} />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={true}
          onChange={handleChange("panel2")}
          style={
            tierMap[subscriptionTier] === "Major"
              ? { backgroundColor: "#1A8899" }
              : styles.accordion
          }
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            style={{ textAlign: "left" }}
          >
            <Box sx={styles.accordionItems}>
              <Typography sx={{ marginLeft: "20px" }}>Major</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <MajorPlanDetails isYearly={isYearly}/>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={true}
          onChange={handleChange("panel4")}
          style={
            tierMap[subscriptionTier] === "Enterprise"
              ? { backgroundColor: "#1A8899" }
              : styles.accordion
          }
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            style={{ textAlign: "left" }}
          >
            <Box sx={styles.accordionItems}>
              <Typography sx={{ marginLeft: "20px" }}>Enterprise</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <EnterpriseDetails />
          </AccordionDetails>
        </Accordion>
      </AccordionContainer>
    </>
  );
};
